export default class Service {
  public name: string
  public school_specific: boolean
  public ad_group_name: string
  public groupe_ad_id: number
  public can_assign: string[]
  public targets: string[]

  constructor(
    name: string,
    school_specific: boolean,
    ad_group_name: string,
    groupe_ad_id: number,
    can_assign: string[],
    targets: string[],
  ) {
    this.name = name
    this.school_specific = false
    this.ad_group_name = ad_group_name
    this.groupe_ad_id = groupe_ad_id
    this.can_assign = can_assign
    this.targets = targets
  }
}
